'use client';

import type { PropsWithChildren } from 'react';
import { createContext, useContext } from 'react';
import type { ClientContextValue } from './types';

const ClientContext = createContext<null | ClientContextValue>(null);

const useClientContext = () => {
  const context = useContext(ClientContext);

  if (!context) {
    // throw new Error('ClientContext must be used within ClientContextProvider'); // It's not mandatory, hence not throwing the error
  }

  return context;
};

function ClientContextProvider(props: PropsWithChildren<ClientContextValue>) {
  const { children, ...rest } = props;
  return <ClientContext.Provider value={rest}>{children}</ClientContext.Provider>;
}

export { useClientContext, ClientContextProvider };
